export default __webpack_public_path__ + "static/media/project-scoring.e160673e.svg";